import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles((theme) => ({
  fieldset: {
    border: 0,
    margin: 0,
    padding: 0,
    minWidth: 0,
  },
}));

const Fieldset = (props) => {
  const classes = useStyles();
  return (
    <fieldset className={classes.fieldset} disabled={props.disabled}>
      {props.children}
    </fieldset>
  );
};

Fieldset.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
};

Fieldset.defaultProps = {
  disabled: false,
};

export default Fieldset;
